import { nanoid } from 'nanoid';
import UserPreferenceSingleton from '../../../../helpers/userPreferenceSingleton';
import { RawFile, RawTask } from '../../../../mobx/interfaces/task';
import { StatusListInterface } from '../../../../interfaces/ProjectInterface';

interface BuildTemplateTaskDataParams {
  createTaskInput: {
    id?: string;
    name?: string;
    estimate?: string | number | null;
    statusId?: string;
    priority?: number;
    groupId?: string;
    files: RawFile[];
  };
  currentProjectTemplate?: {
    companyId?: string;
    id?: string;
  } | null;
  project?: {
    statusEnable?: boolean;
    defaultStatus?: StatusListInterface;
  } | null;
  descriptionData: string;
  taskUsers: string[];
  labelIdList: string[];
}

export function buildTemplateTaskData({
  createTaskInput,
  currentProjectTemplate,
  project,
  descriptionData,
  taskUsers,
  labelIdList
}: BuildTemplateTaskDataParams): RawTask {
  const userDetails = UserPreferenceSingleton.getInstance().getCurrentUser();
  const estimate = typeof createTaskInput?.estimate === 'number' ? createTaskInput.estimate : null;
  return {
    id: createTaskInput?.id || nanoid(),
    name: createTaskInput?.name || '',
    description: descriptionData,
    isArchived: false,
    createdOn: new Date().toISOString(),
    dueDate: null,
    estimate,
    updatedTime: new Date().toISOString(),
    createdBy: userDetails?.id,
    updatedBy: userDetails?.id,
    companyId: currentProjectTemplate?.companyId || '',
    statusId: project?.statusEnable ? (createTaskInput?.statusId || '') ?? project?.defaultStatus?.['_id'] : '',
    priority: createTaskInput?.priority,
    projectId: currentProjectTemplate?.id || '',
    milestoneId: null,
    groupId: createTaskInput?.groupId ?? '',
    parentTaskId: null,
    taskSubscribers: taskUsers,
    users: taskUsers,
    index: null,
    files: createTaskInput?.files || [],
    comments: [],
    labels: labelIdList,
    status: false,
    subtaskIndex: 0,
    taskNumber: 0,
    pullRequests: [],
    links: [],
    recurringInterval: null,
    start: null
  };
}
